var objTicketAssignments = {
    parentObj: null,
    // <summary>
    // This object holds all functions for project, unit and signal assignment related functionality in ticket.js
    // </summary>

    _setAssignmentType: function (me) {
        /// <summary>
        ///  This function sets the correct assignment type name into the caption.
        /// </summary>
        var bFound = false;
        try {

            if (me.entry.Assignments.AssignmentTypes !== null) {

                if (me.entry.Assignments.AssignmentTypes.Bluid !== null) {
                    if (me.entry.Assignments.AssignmentTypes.Bluid > 0) {
                        objTicketAssignments._toggleAssignmentEditButtons(me, me.specific.ASSIGNMENT_UNIT_TYPEID);
                        me.assignmentType = me.specific.ASSIGNMENT_UNIT_TYPEID;
                       
                        return true;
                    }
                }
            }

            for (var i = 0; i < me.entry.Assignments.Assignments.length; i++) {

                if (me.entry.Assignments.Assignments[i].TypeId > -1) {
                    objTicketAssignments._toggleAssignmentEditButtons(me, me.specific.ASSIGNMENT_SIGNAL_TYPEID);
                    me.assignmentType = me.specific.ASSIGNMENT_SIGNAL_TYPEID;
                    bFound = true;
                }
            }
            if (bFound === false) {
                objTicketAssignments._toggleAssignmentEditButtons(me, me.specific.ASSIGNMENT_PROJECT_TYPEID);
                me.assignmentType = me.specific.ASSIGNMENT_PROJECT_TYPEID;
            }


            return true;
        } catch (ex) { me._writeErr(ex); return false }
    },

    _toggleAssignmentEditButtons: function (me,type) {
        /// <summary>
        ///  This function returns an assignment entry id filtered by the type
        /// </summary>
        try {

            me.assignmentType = type;
            me.fnd("#div-assignments #div-edit .button-toggle").removeClass("button-toggle-active");

            switch (me.assignmentType) {
                case me.specific.ASSIGNMENT_PROJECT_TYPEID:
                    me.myHtml.rowMain.assignmentBox.btnAssProject.addClass("button-toggle-active"); break;
                case me.specific.ASSIGNMENT_UNIT_TYPEID:
                    me.myHtml.rowMain.assignmentBox.btnAssUnit.addClass("button-toggle-active"); break;
                case me.specific.ASSIGNMENT_SIGNAL_TYPEID:
                    me.myHtml.rowMain.assignmentBox.btnAssSignals.addClass("button-toggle-active"); break;
            }
        } catch (ex) { me._writeErr(ex); }
    },

    _showAssignments: function (me, edit) {
        /// <summary>
        ///  This function sets the correct assignment type name into the capption.
        /// </summary>
        var myID;
        var my = this;
        try {
            //we have to store the parent object separately
            //because, when we use it later in the vcFilter callback function, this me will have switched to the objTicketAssignments object ;-)
            my.parentObj = me;

            var assBox = me.myHtml.rowMain.assignmentBox;

            myID = my._getAssignmentEntryID(me, me.specific.ASSIGNMENT_PROJECT_TYPEID);
            if (myID === 0) {
                myID = me.entry.Blid;
            }

            me.ddlLogger.setValue(myID, true);
            assBox.txtLogger.html(me.ddlLogger.getOption(me.ddlLogger.getValue()).html());

            if (edit) { assBox.divLogger.show();}

            assBox.divUnit.hide();
            assBox.divHW.hide();
            assBox.divSignals.hide();

           

            switch (me.assignmentType) {
                case me.specific.ASSIGNMENT_PROJECT_TYPEID:
                    if (me.initState) { _VCMQ.produce(me.visual, me.vcgid, 'ASSIGNMENT_LOADED', ""); }
                    break;

                case me.specific.ASSIGNMENT_UNIT_TYPEID:
                    my._fetchAssigmentsUnit(me, me.ddlLogger.getValue(), edit);
                    assBox.txtUnit.html(me.entry.Assignments.Unit);
                    break;

                case me.specific.ASSIGNMENT_SIGNAL_TYPEID:
                    if (edit) {
                        assBox.divSignals.show();
                        if (me.signalFilter !== null) {
                            me.signalFilter.vcFilter("destroy");
                            me.signalFilter = null;
                        }
                        assBox.divSignalFilter.show();
                    
                      
                        me.signalFilter = assBox.divSignalFilter.vcFilter({
                            callback: function () { my._filterSignalList("#div-signals-filter", "#lst-signals"); }
                        });

                    } else {
                        assBox.divSignals.show();
                        assBox.divSignalFilter.hide();
                    }
                    my._fetchAssigmentsSignals(me, me.ddlLogger.getValue(), edit);
                    break;
                default:
            }
        } catch (ex) { me._writeErr(ex); }
    },

    _getAssignmentEntryID: function (me,type) {
        /// <summary>
        ///  This function returns an assignment entry id filtered by the type
        /// </summary>
        try {

            switch (type) {
                case me.specific.ASSIGNMENT_UNIT_TYPEID:
                    if (me.entry.Assignments.AssignmentTypes !== null) {
                        if (me.entry.Assignments.AssignmentTypes.Bluid !== null) {
                            return me.entry.Assignments.AssignmentTypes.Bluid;
                        }
                    }
                    break;
                case me.specific.ASSIGNMENT_SIGNAL_TYPEID:

                    for (var i = 0; i < me.entry.Assignments.Assignments.length; i++) {
                        if (me.entry.Assignments.Assignments[i].TypeId === type) {
                            return me.entry.Assignments.Assignments[i].AssId;
                        }
                    }
                    break;
            }
            return 0;
        } catch (ex) { me._writeErr(ex); return -1 }

    },

    _fetchAssigmentsSignals: function (me, blid, showAll) {
        /// <summary>
        ///  This function fetches a list of signals based on the selected logger id and generates a signal list
        ///  showing the assigned signals
        /// </summary>
        var signals = [];
        try {
            if (me.error) { return false; }

            me.myHtml.rowMain.assignmentBox.signalList.html(me.getLoadingIcon());

            //get all assigned signals
            for (var i = 0; i < me.entry.Assignments.Assignments.length; i++) {
                if (me.entry.Assignments.Assignments[i].TypeId === me.specific.ASSIGNMENT_SIGNAL_TYPEID) {
                    signals.push(me.entry.Assignments.Assignments[i].AssId);
                }
            }
            me.getData({ "typeid": me.specific.ASSIGNMENT_SIGNAL_TYPEID, "entry": { "Blid": blid } },
                function (result) {
                    if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }
                    if (showAll) {
                        me.myHtml.rowMain.assignmentBox.signalList.removeClass("edit").addClass("edit");
                    } else {
                        me.myHtml.rowMain.assignmentBox.signalList.removeClass("edit");
                    }
                    me._fillSublist("signals", result, signals, showAll, me.specific.print);

                    me._validate();

                    if (me.initState) { _VCMQ.produce(me.visual, me.vcgid, 'ASSIGNMENT_LOADED', ""); }

                    return true;
                });

            return true;
        } catch (ex) { me._writeErr(ex); return false }

    },

    _fetchAssigmentsUnit: function (me,blid, edit) {
        /// <summary>
        ///  This function fetches a list of signals based on the selected logger id and generates a signal list
        ///  showing the assigned signals
        /// </summary>
        var myID = 0;
        try {
            if (me.error) { return false; }

            if (blid.length === 0) { blid = -1 }

            me.getData({ "typeid": me.specific.ASSIGNMENT_UNIT_TYPEID, "entry": { "Blid": blid } },
                function (result) {
                    if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }

                    if (me.assignmentType !== me.specific.ASSIGNMENT_UNIT_TYPEID) return true;

                    me.myHtml.rowMain.assignmentBox.ddlUnit.html("");
                    me.myHtml.rowMain.assignmentBox.divUnit.show();
                    if (me.ddlUnit !== null) me.ddlUnit.destroy();

                    me.ddlUnit = me._initSelectize(me.myHtml.rowMain.assignmentBox.ddlUnit, result, true);

                    myID = objTicketAssignments._getAssignmentEntryID(me, me.specific.ASSIGNMENT_UNIT_TYPEID);

                    me.ddlUnit.on("change", function () {
                        objTicketAssignments._fetchAssigmentsHW(me, edit);
                    });

                    if (myID > 0) {
                        me.ddlUnit.setValue(myID, true);
                        me.myHtml.rowMain.assignmentBox.txtUnit.html(me.ddlUnit.getOption(me.ddlUnit.getValue()).html());
                    } else {
                        me.ddlUnit.setValue(-1, true);
                        me.myHtml.rowMain.assignmentBox.txtUnit.html("");
                    }
                  
                    if (edit) {
                        me.myHtml.rowMain.assignmentBox.ddlUnit.show();
                        me.myHtml.rowMain.assignmentBox.txtUnit.hide();
                    } else {
                       
                        me.myHtml.rowMain.assignmentBox.divUnit.find(".selectize-input").hide();
                        me.myHtml.rowMain.assignmentBox.txtUnit.show();
                    }
                    me._validate();
                    objTicketAssignments._fetchAssigmentsHW(me, edit);

                    return true;
                });

            return true;
        } catch (ex) { me._writeErr(ex); return false }

    },

    _fetchAssigmentsHW: function (me, edit) {
        /// <summary>
        ///  This function fetches a list of signals based on the selected logger id and generates a signal list
        ///  showing the assigned signals
        /// </summary>
        var bluid = -1;
        var myID = -1;
        try {
            if (me.error) { return false; }
            if (me.ddlUnit.getValue().length > 0) {
                bluid = parseInt(me.ddlUnit.getValue());
            } else {
                me.entry.Assignments.AssignmentTypes.Blhid = -1;
            }

            me.getData({ "typeid": me.specific.ASSIGNMENT_HW_TYPEID, "entry": { "Blid": bluid } },
                function (result) {

                    if (result === null) { me.showMessage(me.resources.err_loadData, true); return false; }

                    if (me.assignmentType !== me.specific.ASSIGNMENT_UNIT_TYPEID) return true;



                    me.myHtml.rowMain.assignmentBox.ddlHW.html("");

                    if (me.ddlHW !== null) {
                        me.ddlHW.destroy();
                    }

                    me.ddlHW = me._initSelectize(me.myHtml.rowMain.assignmentBox.ddlHW, result, true);

                    if (me.entry.Assignments.AssignmentTypes !== null) {
                        if (me.entry.Assignments.AssignmentTypes.Blhid !== null) {
                            myID = me.entry.Assignments.AssignmentTypes.Blhid;
                        }
                    }


                    if (myID > 0) {
                        me.myHtml.rowMain.assignmentBox.divHW.show();
                        me.ddlHW.setValue(myID, true);
                        me.myHtml.rowMain.assignmentBox.txtHW.html(me.ddlHW.getOption(me.ddlHW.getValue()).html());

                    } else {
                        me.ddlHW.setValue(-1, true);
                        me.myHtml.rowMain.assignmentBox.divHW.hide();
                        me.myHtml.rowMain.assignmentBox.txtHW.html("");
                    }

                    if (edit) {
                        me.myHtml.rowMain.assignmentBox.divHW.show();
                        me.fnd("#div-ddl-hw .edit").show();
                        me.myHtml.rowMain.assignmentBox.txtHW.hide();

                    } else {
                        me.fnd("#div-ddl-hw .edit").hide();
                        me.myHtml.rowMain.assignmentBox.txtHW.show();
                    }

                    me._validate();
                    if (me.initState) { _VCMQ.produce(me.visual, me.vcgid, 'ASSIGNMENT_LOADED', ""); }
                    return true;
                });

            return true;
        } catch (ex) { me._writeErr(ex); return false }

    },

    _changeAssignmentProject: function (me) {
        /// <summary>
        ///  This function changes the assignment onChange of the logger ddl in the assignment box
        /// </summary>
        try {

            if (me.assignmentType === me.specific.ASSIGNMENT_SIGNAL_TYPEID) {
                objTicketAssignments._fetchAssigmentsSignals(me, me.ddlLogger.getValue(), true);
            }

            if (me.assignmentType === me.specific.ASSIGNMENT_UNIT_TYPEID) {
                objTicketAssignments._fetchAssigmentsUnit(me, me.ddlLogger.getValue(), true);
            }
           
            //reload external users and project contacts
            var blid = parseInt(me.ddlLogger.getValue());

            if (!isNaN(blid)) {
                me.entry.Blid = blid;

                objTicketUser._fetchContacts(me, me.entry.Blid);
            }
        } catch (ex) { me._writeErr(ex); }

    },

    _filterSignalList: function (filterObj, list) {
        /// <summary>
        /// This function filters the signal list based on the signal filter
        /// </summary>
        var me = this.parentObj;
        try {
            if (me.error) { return false; }
          
            me.fnd(list + " .vc-list-item").removeClass("found").data("counterfound", 0).hide();
            //we add the 'found' class to all items we want to filter based on the vcfilter tags
            me.setTagFilter(filterObj, list + " .vc-list-item", "found");
            me.fnd(list + " .vc-list-item.found").show();
            me.fnd(list + " .vc-list-item ").removeClass("alt");
            me.fnd(list + " .vc-list-item.found:even").addClass("alt");

            return true;
        } catch (ex) {me._writeErr(ex); return false; }
    },

};